import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IReadReceiptListItem {
    id: string;
    modifyUser: IModifyUser;
    userCompanyName: string;
    userCompanyLogo: string;
}

export class ReadReceiptListItem implements IReadReceiptListItem {
    id: string;
    modifyUser: ModifyUser;
    userCompanyName: string;
    userCompanyLogo: string;

    constructor();
    constructor(obj: IReadReceiptListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.userCompanyName = obj && obj.userCompanyName || "";
        this.userCompanyLogo = obj && obj.userCompanyLogo || "";
    }
}